"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-maggiore": {
    "c81136d9": [{
      "hkey": "42682c69",
      "slug": "castel-maggiore",
      "name": "Castel Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "bondanello": [{
      "hkey": "42682c69",
      "slug": "castel-maggiore",
      "name": "Castel Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65c1469e": [{
      "hkey": "42682c69",
      "slug": "castel-maggiore",
      "name": "Castel Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "42682c69",
      "slug": "castel-maggiore",
      "name": "Castel Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7019df04": [{
      "hkey": "af0f95ca",
      "slug": "garluda-lirone",
      "name": "Garluda-Lirone",
      "primary": true,
      "skipSearch": false
    }],
    "garluda": [{
      "hkey": "af0f95ca",
      "slug": "garluda-lirone",
      "name": "Garluda-Lirone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;